// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLAccordion__ml-accordion div[class*=contentWrapper],.app__MLAccordion__ml-accordion div[class*=outerContentWrapper]{overflow:visible}", "",{"version":3,"sources":["webpack://./../common/modules-react/ml-components-platform-react/MLAccordion/MLAccordion.module.scss"],"names":[],"mappings":"AACI,2HACI,gBAAA","sourcesContent":[".ml-accordion {\n    div[class*='outerContentWrapper'], div[class*='contentWrapper'] {\n        overflow: visible;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ml-accordion": "app__MLAccordion__ml-accordion"
};
export default ___CSS_LOADER_EXPORT___;
